import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import masterServicesApi from '../../../apis/master-services';
import LoadingServiceDetails from '../components/Loading/LoadingServiceDetails';

import { useRegion, Region } from '../../../hooks/useRegion'

import UkServiceForm from './UkServiceForm.jsx';
import CaServiceForm from './CaServiceForm.jsx';

export default function ServiceDetails() {
  const { serviceId } = useParams();
  const isNewService = serviceId === 'create';
  const region = useRegion();

  const { data: avatars } = useQuery({
    queryKey: ['service-avatars'],
    queryFn: masterServicesApi.getServicesAvatars,
    meta: { errorMessage: 'Failed to fetch service avatars' }
  });

  const { data: serviceCategories } = useQuery({
    queryKey: ['service-categories'],
    queryFn: masterServicesApi.getCategories,
    meta: { errorMessage: 'Failed to get service categories' }
  });

  const { data: service } = useQuery({
    queryKey: ['master-service', serviceId],
    queryFn: ({ queryKey }) => masterServicesApi.getServiceById(queryKey[1]),
    enabled: !isNewService,
    meta: { errorMessage: 'Failed to fetch service' }
  });

  if (!avatars || !serviceCategories || (!isNewService && !service)) return <LoadingServiceDetails />;

  const categories = serviceCategories.filter((category) => category._id !== 'no_category');

  if (region === Region.UK) {
    return <UkServiceForm service={service} avatars={avatars} categories={categories} />;
  }

  return <CaServiceForm service={service} avatars={avatars} categories={categories} />;
}
